import React, { useContext } from 'react';
import Loading from 'react-loading';
import { useMsal } from '@azure/msal-react';
import { useAsync } from 'react-commons';
import { Col, Container, Row } from 'react-bootstrap';
import UserContext from '../../contexts/UserContext';
import LocalizationContext from '../../contexts/LocalizationContext';
import { getMyInfo } from '../../utils/GraphUtils';

var BasicUserConfig = function BasicUserConfig() {
  var userInfo = useContext(UserContext);
  var localizedStrings = useContext(LocalizationContext);

  var _useMsal = useMsal(),
      instance = _useMsal.instance;

  if (userInfo) {
    var defaultState = {
      locale: '',
      timezone: ''
    };

    var _useAsync = useAsync(function () {
      return getMyInfo(instance);
    }, defaultState),
        value = _useAsync.value,
        loading = _useAsync.loading;

    if (loading || value === null) {
      return /*#__PURE__*/React.createElement(Loading, {
        "data-testid": "loading-user-config"
      });
    }

    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
      className: "mt-6"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 12,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("h2", null, localizedStrings.lorule.userProfile.title), /*#__PURE__*/React.createElement("h2", {
      className: "border-bottom mt-2"
    }, " "))), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3 ml-1"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 5,
      className: "font-weight-bold"
    }, localizedStrings.lorule.userProfile.name), /*#__PURE__*/React.createElement(Col, {
      sm: 7
    }, userInfo.displayName)), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3 ml-1"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 5,
      className: "font-weight-bold"
    }, localizedStrings.lorule.userProfile.username), /*#__PURE__*/React.createElement(Col, {
      sm: 7
    }, userInfo.id)));
  }

  return null;
};

export default BasicUserConfig;